// FacilityRegistrationValidationSchema.ts
import * as yup from "yup";

export const FacilityRegistrationValidationSchema = yup.object().shape({
  userEmail: yup
    .string()
    .nullable()
    .email("Invalid email format")
    .required("Email is required"),

  hospitalName: yup
    .string()
    .required("Facility Name is required"),

    hospitalTypeId: yup
    .number()
    .min(1, "Hospital Type is required")
    .required("Hospital Type is required"),

  hospitalAddress: yup
    .string()
    .required("Facility Address is required"),

  hospitalCity: yup
    .string()
    .required("City is required"),

  hospitalZipCode: yup
    .string()
    .matches(/^\d{5}$/, "Zip Code must be 5 digits")
    .required("Zip Code is required"),

    stateId: yup.number()
    .min(1, "State is required")
    .required("State is required"),

    countyId: yup.number()
    .min(1, "County is required")
    .required("County is required"),

  userFirstName: yup
    .string()
    .required("First Name is required"),

  userLastName: yup
    .string()
    .required("Last Name is required"),

  userPhoneNumber: yup
    .string()
    .required("Phone Number is required"),

    roleId: yup
    .number()
    .nullable()
    .notRequired(),
    isApproved: yup.boolean().nullable().notRequired(),
    createdBy: yup.string().notRequired(),
    dateCreated: yup.string().notRequired(),
});
